// 落地页

const LandingPage = r => require.ensure(
  [],
  () => r(require('@/components/landing-page/landing-page')),
  'LandingPage'
)

export default [
  {
    path: '/LandingPage',
    name: 'LandingPage',
    component: LandingPage
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/landing-page.js